import { render, staticRenderFns } from "./client-floating-actions.vue?vue&type=template&id=c97f3326&scoped=true&"
import script from "./client-floating-actions.vue?vue&type=script&lang=js&"
export * from "./client-floating-actions.vue?vue&type=script&lang=js&"
import style0 from "./client-floating-actions.vue?vue&type=style&index=0&id=c97f3326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97f3326",
  null
  
)

export default component.exports